import { Redirect, Route, Switch } from "react-router-dom";
//
import "./app.scss";
import { useState } from "react";
import Home from "containers/home/home";
import Galaxy from "containers/galaxy/galaxy";
import Form from "containers/form/form";
import { ROUTES } from "constants/routes";
import Loader from "components/loader/loader";
import Background from "components/background/background";
import { useStore } from "shell/store/store";

export type AppTypes = {
  loading: boolean;
  onLoaded: () => void;
};

const App: React.FC<{}> = () => {
  const [loading, setLoading] = useState<boolean>(true);
  const language = useStore((state) => state.language);

  const handleLoaded = () => {
    setLoading(false);
  };

  const routeProps = {
    onLoaded: handleLoaded,
    loading: loading,
  };

  console.log(language)
  //
  return (
    <div className="app">
      {/* <Helmet>
        <html lang={language} />
        <title>
          {language === "fr" ? metaData.fr.title : metaData.de.title}
        </title>
        <meta
          name="description"
          content={language === "fr" ? metaData.fr.desc : metaData.de.desc}
        />
         <meta property="og:title" content={language === "fr" ? metaData.fr.title : metaData.de.title} />
         <meta property="og:description" content={language === "fr" ? metaData.fr.desc : metaData.de.desc} />
        <meta property="og:url" content={"https://www.epicmode.ch/" + language + "/"} />
      </Helmet> */}
      {/* BACKGROUND */}
      <Background />
      {/* TOP BAR */}
      <Switch>
        <Route
          path={ROUTES.Home}
          exact
          component={() => <Home {...routeProps} />}
        />
        <Route
          path={ROUTES.Epic}
          exact
          component={() => <Home {...routeProps} />}
        />
        <Route
          path={ROUTES.Galaxy}
          component={() => <Galaxy {...routeProps} />}
        />
        <Route path={ROUTES.Form} component={() => <Form {...routeProps} />} />
        <Redirect to={ROUTES.Epic} />
      </Switch>
      {/* LOADER */}
      <Loader loading={loading} />
    </div>
  );
};

export default App;
